import MainLayout from '@/layouts/MainLayout.vue';

const externalRouters = {
    path: '/',
    component: MainLayout,
    children: [
        {
            path: '',
            name: 'HomePage',
            component: () => import('../pages/HomePage.vue'),
            meta: {
                isCustomLang: true,
            },
        },
        {
            path: '/collection',
            name: 'CollectionPage',
            component: () => import('../pages/CollectionPage.vue'),
            meta: {
                isCustomLang: true,
            },
        },
        {
            path: '/history-transaction',
            name: 'TransactionHistory',
            component: () => import('../pages/TransactionHistory.vue'),
            meta: {
                isCustomLang: true,
                requiresAuth: true,
            },
        },

        {
            path: '/change-password',
            name: 'ChangePasswordPage',
            component: () => import('../pages/ChangePasswordPage.vue'),
            meta: {
                isCustomLang: true,
                requiresAuth: true,
            },
        },
    ],
};

export const HomePageRouters = [externalRouters];
